import React from 'react';
import {withRouter} from 'react-router';
import {get as _get} from 'lodash';
import PropTypes from 'prop-types';

import {
    ORIGIN_STREAM_TYPE_MEDIACONNECT,
    ORIGIN_STREAM_TYPE_UDP,
    ORIGIN_STREAM_TYPE_SRT,
} from '@constants/variables';
import {convertToInt} from '@utils/helpers';
import {isContentHasInputAndEncoderSportradar} from '@modules/events/utils/eventsConfigurationTargetsTableHelper';
import IconSubtitle from '@modules/events/views/EventsConfigurationTargetsTable/IconSubtitle';

const originStreamTypes = [
    ORIGIN_STREAM_TYPE_UDP,
    ORIGIN_STREAM_TYPE_MEDIACONNECT,
    ORIGIN_STREAM_TYPE_SRT,
];

const IconsSubtitleConfiguration = ({match, content, tableRow}) => {
    const originStreamType = convertToInt(_get(content, 'event_content_input.origin_stream_type.id', null));

    if (!isContentHasInputAndEncoderSportradar(content, tableRow) || !originStreamTypes.includes(originStreamType)) {
        return null;
    }

    const linkParams = {
        id: match.params.id,
        contentId: content.id,
        targetId: tableRow.id,
    };
    let iconName = 'customIcon-subtitle-border-only';

    if (0 < tableRow.subtitles.length) {
        iconName = 'customIcon-subtitle';
    }

    return <IconSubtitle iconName={iconName} linkParams={linkParams}/>;
};

IconsSubtitleConfiguration.propTypes = {
    match: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
    tableRow: PropTypes.object.isRequired,
};
IconsSubtitleConfiguration.displayName = 'IconsSubtitleConfiguration';


export default withRouter(IconsSubtitleConfiguration);
